/**
 * Report rows returned by the assistant. Columns come from the server spec.
 *
 * @param {{ report: { columns?: string[], rows?: object[] } }} props
 */
export default function ReportTable({ report }) {
  const columns = report?.columns || [];
  const rows = report?.rows || [];
  if (columns.length === 0) return null;

  return (
    <div className="overflow-x-auto rounded-lg border border-gray-200">
      <table className="min-w-full text-left text-sm">
        <thead className="bg-gray-50 text-gray-600">
          <tr>
            {columns.map((column) => (
              <th key={column} className="px-3 py-2 font-medium">
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index} className="border-t border-gray-100">
              {columns.map((column) => (
                <td key={column} className="px-3 py-2 text-gray-800">
                  {row[column] === undefined || row[column] === null
                    ? ""
                    : String(row[column])}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
